import { Grow, Popper as MUIPopper, Paper, PopperProps, styled } from '@mui/material';
import { PropsWithChildren, useState } from 'react';

const PopperWithArrow = styled(MUIPopper)(({ theme }) => ({
    zIndex: 1,
    '& > div': {
        position: 'relative',
    },
    '&[data-popper-placement*="bottom"]': {
        '& > div': {
            marginTop: 2,
        },
        '& .MuiPopper-arrow': {
            top: 0,
            left: 0,
            marginTop: '-1.1em',
            width: '3em',
            height: '1em',
            '&::before': {
                borderWidth: '0 1em 1em 1em',
                borderColor: `transparent transparent ${theme.palette.background.paper} transparent`,
            },
        },
    },
    '&[data-popper-placement*="top"]': {
        '& > div': {
            marginBottom: 2,
        },
        '& .MuiPopper-arrow': {
            bottom: 0,
            left: 0,
            marginBottom: '-1.1em',
            width: '3em',
            height: '1em',
            '&::before': {
                borderWidth: '1em 1em 0 1em',
                borderColor: `${theme.palette.background.paper} transparent transparent transparent`,
            },
        },
    },
    '&[data-popper-placement*="right"]': {
        '& > div': {
            marginLeft: 2,
        },
        '& .MuiPopper-arrow': {
            left: 0,
            marginLeft: '-1.1em',
            height: '3em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 1em 1em 0',
                borderColor: `transparent ${theme.palette.background.paper} transparent transparent`,
            },
        },
    },
    '&[data-popper-placement*="left"]': {
        '& > div': {
            marginRight: 2,
        },
        '& .MuiPopper-arrow': {
            right: 0,
            marginRight: '-1.1em',
            height: '3em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 0 1em 1em',
                borderColor: `transparent transparent transparent ${theme.palette.background.paper}`,
            },
        },
    },
}));

const Arrow = styled('div')(({ theme }) => ({
    position: 'absolute',
    fontSize: 7,
    width: '3em',
    height: '3em',
    '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: 0,
        height: 0,
        borderStyle: 'solid',
    },
}));

export const Popper = ({ children, arrow = true, ...props }: PopperProps & PropsWithChildren & { arrow?: boolean }) => {
    const [arrowRef, setArrowRef] = useState<HTMLElement | null>(null);
    return (
        <PopperWithArrow
            modifiers={
                arrow
                    ? [
                          {
                              name: 'arrow',
                              enabled: true,
                              options: {
                                  element: arrowRef,
                              },
                          },
                      ]
                    : undefined
            }
            {...props}
        >
            {({ TransitionProps }) => (
                <Grow {...TransitionProps} timeout={350}>
                    <Paper
                        className="border rounded-lg"
                        sx={{ borderColor: (theme) => theme.palette['neutral-450'].main }}
                    >
                        {arrow && <Arrow ref={setArrowRef} className="MuiPopper-arrow" />}
                        {children}
                    </Paper>
                </Grow>
            )}
        </PopperWithArrow>
    );
};
